var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-indicator"},[_c('img',{staticClass:"progress-image",attrs:{"src":require("@/assets/loader.svg")}}),_c('div',{staticClass:"percent-label"},[_vm._v(" "+_vm._s(_vm.percent)+"% Complete ")])])}
var staticRenderFns = []

export { render, staticRenderFns }